module.exports = __webpack_public_path__ + "img/l-07.504a5759.png";